import React from 'react';
import { CONSTANTS } from '../Helpers/Constants';

export const AppContext = React.createContext();
const Provider = AppContext.Provider;

const AppProvider = ({ children }) => {
    const [token, setToken] = React.useState(
        JSON.parse(localStorage.getItem(CONSTANTS.LOCAL_STORAGE_KEYS.USER)) || null
    )
    const [currentUser, setCurrentUser] = React.useState(null)

    const data = {
        token,
        setToken,
        currentUser,
        setCurrentUser
    };

    return (
        <Provider value={data}>{children}</Provider>
    )
};

export default AppProvider;